import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { IBlog } from '../blogs/blog';
import { BlogType } from './blogtypes';
import { BlogService } from '../blogs/blog.service';
declare var $: any;
@Component({
  templateUrl: "./myfuelcardaccount.component.html"
})
export class MyFuelCardAccount implements OnInit, AfterViewInit, OnDestroy {
  public pageTitle: string = 'My Fuel Card Account';
  blogsList: IBlog[];
  category: string;
  constructor(private authService: AuthService,
    private appCommonService: AppCommonService,
    public blogService: BlogService,
  ) {
    this.appCommonService.pageContentAdditionalClass = "home-page main-page";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit() {
    this.category = BlogType.myfuelcardaccount;
    this.loadBlogsList();
    window.scrollTo(0, 0);
    this.appCommonService.hideContact();
  }

  ngOnDestroy() {
    this.appCommonService.showContact();
  }

  ngAfterViewInit() {
    this.appCommonService.loadRequiredJS();
    $('.tabs-left li a').hover(function () {      
      $(this).trigger('click');
    });
    $('.sliderformobile').bxSlider({
      auto: true,
      pager: true,
      controls: false,
      touchEnabled: true,
      adaptiveHeight: true
    });
  }

  loadBlogsList() {
    this.blogService.getBlogsList(this.category)
      .subscribe(
      (blogs: IBlog[]) => {        
        this.blogsList = blogs;
      },
      (error: any) => {
        this.blogService.showError("Blog retrieval problem", <any>error)
      }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/genericpages/myfuelcardaccount.component.ts